<template>
  <div>
    <div class="examine_title_box">
      <div class="examine_title">我的考核</div>
      <el-date-picker
        v-model="timeData"
        type="month"
        format="yyyy-MM"
        defaule-value="dafaultValue"
        @change="timeChange"
        placeholder="选择月"
      >
      </el-date-picker>
    </div>
    <div class="examine_box">
      <div class="tab_tit">
        <a @click="getDay()" :class="{ cur: curId === 1 }">日</a>
        <a @click="getWeek()" :class="{ cur: curId === 2 }">周</a>
        <a @click="getMonth()" :class="{ cur: curId === 3 }">月</a>
      </div>
      <div class="tab_con">
        <!-- 我的考核--日 -->
        <div v-show="curId === 1">
          <div class="day_list">
            <div
              class="day_item"
              v-for="i in daysList"
              :key="i"
              @click="checkDay(i)"
            >
              <div>{{ i }}</div>
              <div :class="{ checked: currentDay == i }"></div>
            </div>
          </div>
          <div class="card_box">
            <el-card class="box-card card_item">
              <div class="card_title">
                <div class="title_txt">总分</div>
                <span>TOTAL POINTS</span>
              </div>
              <div class="card_data">
                <div>
                  <span class="card_num"
                    >{{ examineDayList.total_point || 0 }} </span
                  >分
                </div>
                <img src="@/assets/image/total.png" alt="" />
              </div>
            </el-card>
            <el-card class="box-card card_item">
              <div class="card_title">
                <div class="title_txt">成交分</div>
                <span>TRANSACTION SCORE</span>
              </div>
              <div class="card_data">
                <div>
                  <span class="card_num">{{
                    examineDayList.bargain_point || 0
                  }}</span
                  >分
                </div>
                <img src="@/assets/image/success.png" alt="" />
              </div>
            </el-card>
            <el-card class="box-card card_item">
              <div class="card_title">
                <div class="title_txt">沟通分</div>
                <span>COMMUNICATION SCORE</span>
              </div>
              <div class="card_data">
                <div>
                  <span class="card_num">{{
                    examineDayList.connect_point || 0
                  }}</span
                  >分
                </div>
                <img src="@/assets/image/communicate.png" alt="" />
              </div>
            </el-card>
            <el-card class="box-card card_item">
              <div class="card_title">
                <div class="title_txt">字数分</div>
                <span>NUMBER OF WORDS</span>
              </div>
              <div class="card_data">
                <div>
                  <span class="card_num">{{
                    examineDayList.wordnumber_point || 0
                  }}</span
                  >分
                </div>
                <img src="@/assets/image/font.png" alt="" />
              </div>
            </el-card>
            <el-card class="box-card card_item">
              <div class="card_title">
                <div class="title_txt">考勤分</div>
                <span>ATTENDANCE SCORE</span>
              </div>
              <div class="card_data">
                <div>
                  <span class="card_num">{{
                    examineDayList.attend_point || 0
                  }}</span
                  >分
                </div>
                <img src="@/assets/image/attend.png" alt="" />
              </div>
            </el-card>
            <el-card class="box-card card_item">
              <div class="card_title">
                <div class="title_txt">新增分</div>
                <span>INCREASE SCORE</span>
              </div>
              <div class="card_data">
                <div>
                  <span class="card_num">{{
                    examineDayList.create_point || 0
                  }}</span
                  >分
                </div>
                <img src="@/assets/image/increase.png" alt="" />
              </div>
            </el-card>
          </div>
          <div class="examine_upload_box">
            <div class="examine_upload_title">沟通上传</div>
            <div class="examine_upload_control upload_box">
              <el-upload
                class="upload-demo examine_upload"
                :on-remove="handleRemove"
                :file-list="dayImgList"
                :on-success="handleUploadSuccess"
                list-type="picture"
                :action="uploadUrl"
              >
                <div class="el-upload__text">
                  <i class="iconfont icon-shangchuan"></i>上传沟通截图
                </div>
              </el-upload>
            </div>
          </div>
        </div>
        <!-- 我的考核--周 -->
        <div v-show="curId === 2">
          <div class="week_list">
            <div
              class="week_item"
              v-for="(i, index) in weekList"
              :key="index"
              @click="checkWeek(i)"
            >
              <div>第{{ i.weeknum }}周</div>
              <div :class="{ checked: weeknum == i.weeknum }"></div>
            </div>
          </div>
          <div class="week_box">
            <div class="week_chart">
              <div id="week_chart" style="width: 700px; height: 410px"></div>
            </div>
            <el-card class="box-card">
              <div class="week_card">
                <div class="week_card_left">
                  <div class="week_card_left_top">
                    <div class="card_title">
                      <div class="title_txt">总分</div>
                      <span>TOTAL POINTS</span>
                    </div>
                    <div class="week_data_box">
                      <div>
                        <span class="card_num">{{
                          weekDataList.total_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/total.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="card_line"></div>
                <div class="week_card_right">
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">成交分</div>
                      <span>TRANSACTION SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div>
                        <span class="card_num">{{
                          weekDataList.bargain_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/success.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">沟通分</div>
                      <span>COMMUNICATION SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div>
                        <span class="card_num">{{
                          weekDataList.connect_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/communicate.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">字数分</div>
                      <span>NUMBER OF WORDS</span>
                    </div>
                    <div class="week_data_right_box">
                      <div>
                        <span class="card_num">{{
                          weekDataList.wordnumber_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/font.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">考勤分</div>
                      <span>ATTENDANCE SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div>
                        <span class="card_num">{{
                          weekDataList.attend_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/attend.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">新增分</div>
                      <span>INCREASE SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div>
                        <span class="card_num">{{
                          weekDataList.create_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/increase.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="examine_upload_box">
            <div class="examine_upload_title">沟通上传</div>
            <div class="examine_upload_control upload_box">
              <el-upload
                class="upload-demo examine_upload"
                :on-remove="handleRemove"
                :file-list="dayImgList"
                :on-success="handleUploadSuccess"
                list-type="picture"
                :action="uploadUrl"
              >
                <div class="el-upload__text">
                  <i class="iconfont icon-shangchuan"></i>上传沟通截图
                </div>
              </el-upload>
            </div>
          </div>
        </div>
        <!-- 我的考核--月 -->
        <div v-show="curId === 3">
          <div class="week_list">
            <div
              class="week_item"
              v-for="i in 12"
              :key="i"
              @click="checkMonth(i)"
            >
              <div>{{ i }}月</div>
              <div :class="{ checked: currentMonth == i }"></div>
            </div>
          </div>
          <div class="week_box">
            <div class="week_chart">
              <div id="month_chart" style="width: 720px; height:410px"></div>
            </div>
            <el-card class="box-card">
              <div class="week_card">
                <div class="week_card_left">
                  <div class="week_card_left_top">
                    <div class="card_title">
                      <div class="title_txt">总分</div>
                      <span>TOTAL POINTS</span>
                    </div>
                    <div class="month_data_box">
                      <div class="num_box">
                        <div class="card_num card_num_month">
                          {{ monthList.total_point || 0 }}
                        </div>
                        <div class="fen">分</div>
                      </div>
                      <img src="@/assets/image/total.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="card_line"></div>
                <div class="week_card_right">
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">成交分</div>
                      <span>TRANSACTION SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div class="num_box">
                        <div class="card_num ">
                          {{ monthList.bargain_point || 0 }}
                        </div>
                        <div class="fen">分</div>
                      </div>
                      <img src="@/assets/image/success.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">沟通分</div>
                      <span>COMMUNICATION SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div class="num_box">
                        <div class="card_num ">
                          {{ monthList.connect_point || 0 }}
                        </div>
                        <div class="fen">分</div>
                      </div>
                      <img src="@/assets/image/communicate.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">字数分</div>
                      <span>NUMBER OF WORDS</span>
                    </div>
                    <div class="week_data_right_box">
                      <div class="num_box">
                        <div class="card_num ">
                          {{ monthList.wordnumber_point || 0 }}
                        </div>
                        <div class="fen">分</div>
                      </div>
                      <img src="@/assets/image/font.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">考勤分</div>
                      <span>ATTENDANCE SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div class="num_box">
                        <div class="card_num ">
                          {{ monthList.attend_point || 0 }}
                        </div>
                        <div class="fen">分</div>
                      </div>
                      <img src="@/assets/image/attend.png" alt="" />
                    </div>
                  </div>
                  <div class="week_card_right_item">
                    <div class="card_title">
                      <div class="title_txt">新增分</div>
                      <span>INCREASE SCORE</span>
                    </div>
                    <div class="week_data_right_box">
                      <div>
                        <span class="card_num ">{{
                          monthList.create_point || 0
                        }}</span
                        >分
                      </div>
                      <img src="@/assets/image/increase.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="examine_upload_box">
            <div class="examine_upload_title">沟通上传</div>
            <div class="examine_upload_control upload_box">
              <el-upload
                class="upload-demo examine_upload"
                :on-remove="handleRemove"
                :file-list="dayImgList"
                :on-success="handleUploadSuccess"
                list-type="picture"
                :action="uploadUrl"
              >
                <div class="el-upload__text">
                  <i class="iconfont icon-shangchuan"></i>上传沟通截图
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { examine_list, upload_connectpoints } from "@/utils/writer";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      writerId: "", //所属写手部门id
      currentdate: "", //当前时间
      currentDay: "", //当前日期
      currentMonth: "", //当前月
      examineDayList: [], //日-列表
      daysList: [], //当前月份的天数
      monthList: [], //月考勤数据
      monthChartList: [], //月图表数据
      currentTime: "", //当前年月日
      dayImgList: [], //日图片列表
      dayImgUrl: "", //图片地址
      weekFileList: [], //周文件列表
      monthFileList: [], //月文件列表
      weekList: [], //周列表
      weekDataList: [], //周数据列表
      weekChartList: [], //周图表数据
      timeData: [], //当前年-月
      curId: 1, //当前选项卡
      weeknum: 1, //当前周次
      selectMonth: false //是否选择时间
    };
  },

  created() {
    this.getNowTime();
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getExamineList(this.curId);
    console.log("图片列表", this.dayImgList);
  },
  methods: {
    getExamineList() {
      var that = this;
      var now = new Date();
      now.setTime(now.getTime());
      that.currentTime =
        now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      that.currentDay = now.getDate();
      var time_obj = that.currentTime + " - " + that.currentTime;
      let obj = {
        departmentuser_id: that.writerId,
        type: 1,
        time: time_obj //time_obj
      };
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          that.examineDayList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取日考勤
    getDay() {
      var that = this;
      that.curId = 1;
      that.getExamineList();
    },
    // 选择日考勤
    checkDay(val) {
      var that = this;
      var time_obj;
      that.currentDay = val;
      if (that.selectMonth == false) {
        var now = new Date();
        now.setTime(now.getTime());
        that.currentTime =
          now.getFullYear() +
          "-" +
          (now.getMonth() + 1) +
          "-" +
          that.currentDay;
        time_obj = that.currentTime + " - " + that.currentTime;
      } else {
        var date = that.timeData + "-" + that.currentDay;
        time_obj = date + " - " + date;
      }

      let obj = {
        departmentuser_id: that.writerId,
        type: 1,
        time: time_obj
      };
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          that.examineDayList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选择周
    checkWeek(val) {
      var that = this;
      that.weeknum = val.weeknum;
      var time_obj = val.beginTime + " - " + val.endTime;
      let obj = {
        departmentuser_id: that.writerId,
        type: 2,
        time: time_obj
      };
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          that.weekDataList = res.data.data;
          that.weekChartList = res.data.data.list;
          that.weekChart();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取周考勤
    getWeek() {
      var that = this;
      var current_time, time_obj;
      var week_year, week_month;
      var now = new Date();
      that.curId = 2;
      if (this.selectMonth == false) {
        // 未选月份，当前月份
        week_year = now.getFullYear();
        week_month = now.getMonth() + 1;
        var weekDataList = this.getWeekData(week_year, week_month);
        that.weekList = weekDataList;
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var curDate = date.getDate();
        current_time = year + "-" + month + "-" + curDate;
      } else {
        // 选择了月份
        var date = new Date();
        var curDate = date.getDate();
        week_year = that.timeData.substring(0, 4);
        week_month = that.timeData.slice(
          that.timeData.length - 2,
          that.timeData.length
        );
        var weekDataList = this.getWeekData(week_year, week_month);
        that.weekList = weekDataList;
        current_time = that.timeData + "-" + curDate;
      }
      var a, b;
      weekDataList.forEach(item => {
        var begin = new Date(item.beginTime);
        var end = new Date(item.endTime);
        var current = new Date(current_time);
        console.log(item.beginTime, item.endTime);
        a = current - begin;
        b = current - end;
        if (a < 0 || b > 0) {
          console.log("不存在", weekDataList);
          that.weeknum = weekDataList[0].weeknum;
          time_obj =
            weekDataList[0].beginTime + " - " + weekDataList[0].endTime;
        } else {
          that.weeknum = item.weeknum;
          time_obj = item.beginTime + " - " + item.endTime;
        }
      });

      let obj = {
        departmentuser_id: that.writerId,
        type: 2,
        time: time_obj
      };
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          that.weekDataList = res.data.data;
          that.weekChartList = res.data.data.list;
          that.weekChart();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 获取月考勤
    getMonth() {
      var that = this;
      that.curId = 3;

      var now = new Date();
      now.setTime(now.getTime());
      that.currentMonth = now.getMonth() + 1;
      var time = that.timeQuantum(that.currentMonth);

      let obj = {
        departmentuser_id: that.writerId,
        type: that.curId,
        time: time
      };
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          that.monthList = res.data.data;
          that.monthChartList = res.data.data.list;
          that.monthChart();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选择月份
    checkMonth(val) {
      var that = this;
      that.currentMonth = val;
      var time = that.timeQuantum(that.currentMonth);
      let obj = {
        departmentuser_id: that.writerId,
        type: that.curId,
        time: time
      };
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          that.monthList = res.data.data;
          that.monthChartList = res.data.data.list;
          that.monthChart();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 获取周次
    getWeekData(year, month) {
      //传入  年  月  获取当月有几周 以及日期
      var new_year = year; //取当前的年份
      var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (new_month < 10) {
        new_month = "0" + new_month;
      }
      var weekDay = [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期天"
      ];
      if (new_month > 12) {
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      var first_date = new Date(new_year, new_month, 1); //取当年当月中的第一天-时间格式
      var last_Data = new Date(
        first_date.getTime() - 1000 * 60 * 60 * 24
      ).getDate(); //获取当月最后一天日期
      //当月第一天是周几
      var firstzhouji =
        new Date(new_year + "/" + new_month + "/" + 1).getDay() == 0
          ? "星期天"
          : weekDay[
              new Date(new_year + "/" + new_month + "/" + 1).getDay() - 1
            ];
      //当月最后一天是周几
      var lastzhouji =
        new Date(new_year + "/" + new_month + "/" + last_Data).getDay() == 0
          ? "星期天"
          : weekDay[
              new Date(new_year + "/" + new_month + "/" + last_Data).getDay() -
                1
            ];
      var firsttime = ""; //第一周有几天
      if (firstzhouji == "星期一") {
        firsttime = 7;
      }
      if (firstzhouji == "星期二") {
        firsttime = 6;
      }
      if (firstzhouji == "星期三") {
        firsttime = 5;
      }
      if (firstzhouji == "星期四") {
        firsttime = 4;
      }
      if (firstzhouji == "星期五") {
        firsttime = 3;
      }
      if (firstzhouji == "星期六") {
        firsttime = 2;
      }
      if (firstzhouji == "星期天") {
        firsttime = 1;
      }

      var lasttime = ""; //最后一周有几天
      if (lastzhouji == "星期一") {
        lasttime = 1;
      }
      if (lastzhouji == "星期二") {
        lasttime = 2;
      }
      if (lastzhouji == "星期三") {
        lasttime = 3;
      }
      if (lastzhouji == "星期四") {
        lasttime = 4;
      }
      if (lastzhouji == "星期五") {
        lasttime = 5;
      }
      if (lastzhouji == "星期六") {
        lasttime = 6;
      }
      if (lastzhouji == "星期天") {
        lasttime = 7;
      }

      // 前后两周  加上 剩余周数  得出总周数
      var contime = 2 + (last_Data - lasttime - firsttime) / 7;

      //得出每周对应的日期
      var zhouArry = [];

      for (var i = 1; i <= contime; i++) {
        var strTime = "";
        var lastTime = "";
        if (i == 1) {
          strTime = year + "-" + new_month + "-" + "01";
          let aa = 1 + firsttime - 1;
          if (aa < 10) {
            aa = "0" + aa;
          }
          lastTime = year + "-" + new_month + "-" + aa;
        } else if (i == contime) {
          let bb = last_Data - lasttime + 1;
          if (bb < 10) {
            bb = "0" + bb;
          }
          strTime = year + "-" + new_month + "-" + bb;
          lastTime =
            year +
            "-" +
            new_month +
            "-" +
            (last_Data < 10 ? "0" + last_Data : last_Data);
        } else {
          strTime = addDate(zhouArry[zhouArry.length - 1].endTime, 1);
          lastTime = addDate(zhouArry[zhouArry.length - 1].endTime, 7);
        }

        zhouArry.push({
          weeknum: i,
          beginTime: strTime,
          endTime: lastTime
        });

        //日期增加 接受两个参数， 传入的时间，传入时间增加的天数
        function addDate(date, days) {
          if (days == undefined || days == "") {
            days = 1;
          }
          var date = new Date(date);
          date.setDate(date.getDate() + days);
          var month = date.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var day = date.getDate();
          if (day < 10) {
            day = "0" + day;
          }
          return date.getFullYear() + "-" + month + "-" + day;
        }
      }
      console.log("zhouArry", zhouArry);
      return zhouArry;
    },
    // 月份的的第一天和最后一天
    timeQuantum(currentMonth) {
      var date = new Date(); // this.startTime = '2022-5-02'
      var new_year = date.getFullYear(); // 取当前的年份
      var month = currentMonth;
      var new_month = currentMonth; // 取当前的月份
      if (month > 12) {
        new_month -= 12; // 月份减
        new_year++; // 年份增
      }
      var firstDay = new Date(new_year, new_month, 1); // 取当年当月中的第一天
      var lastDay = new Date(
        firstDay.getTime() - 1000 * 60 * 60 * 24
      ).getDate(); // 获取当月最后一天日期
      if (firstDay.getMonth() < 10) {
        var mon = "0" + firstDay.getMonth();
      } else {
        var mon = firstDay.getMonth();
      }
      var startDate =
        firstDay.getFullYear() + "-" + mon + "-" + "0" + firstDay.getDate();
      var endDate = firstDay.getFullYear() + "-" + mon + "-" + lastDay;
      return startDate + " - " + endDate;
    },

    // 时间格式转化----年/月
    getYearMonth(date) {
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return year + "-" + month;
    },
    // 选择月份
    timeChange() {
      var that = this;
      that.timeData = that.getYearMonth(that.timeData);
      let result = that.timeData.split("-");
      that.daysList = that.getDaysInMonth(result[0], result[1]);
      var time_obj = that.timeData + "-" + that.currentDay;
      console.log("周次", time_obj);
      let obj = {
        departmentuser_id: that.writerId,
        type: that.curId,
        time: time_obj + " - " + time_obj //time_obj
      };
      console.log("周次参数", obj);
      examine_list(obj).then(res => {
        if (res.data.code == 1) {
          if (that.curId == 1) {
            // 日数据
            that.examineDayList = res.data.data;
          } else if (that.curId == 2) {
            // 周数据
            that.weekDataList = res.data.data;
            that.getWeek();
          } else {
            // 月数据
            that.monthList = res.data.data;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
      that.selectMonth = true;
    },
    // 获取当前月份
    getNowTime() {
      var that = this;
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      month = month + 1;
      month = month.toString().padStart(2, "0");
      that.timeData = `${year}-${month}`;
      that.daysList = that.getDaysInMonth(year, month);
    },

    // 获取天数
    getDaysInMonth(year, month) {
      let temp = new Date(year, month, 0);
      let days = temp.getDate();
      return days;
    },
    // 图片删除
    handleRemove(file, fileList) {
      var that = this;
      if (fileList.length == 0) {
        that.dayImgList = [];
      } else {
        that.dayImgList = fileList;
      }
      that.uploadImgs(that.dayImgList);
    },
    //图片上传
    uploadImgs(dayImgList) {
      var that = this;
      var imgUrl;
      let obj;
      if (dayImgList.length == 1) {
        imgUrl = dayImgList[0].response.data.url;
        obj = {
          departmentuser_id: that.writerId,
          images: imgUrl
        };
      } else {
        var img_arr = [];
        dayImgList.forEach(item => {
          img_arr.push(item.response.data.url);
        });

        imgUrl = img_arr.join(",");
        obj = {
          departmentuser_id: that.writerId,
          images: imgUrl
        };
      }
      upload_connectpoints(obj).then(res => {
        if (res.data.code == 1) {
          that.dayImgList = [];
          that.$message.success(res.data.msg);
          // console.log("列表刷新了");
          // location.reload();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 图片上传后
    handleUploadSuccess(response, file, fileList) {
      var that = this;
      if (fileList.length == 1) {
        if (typeof fileList[0].response != "undefined") {
          that.dayImgUrl = fileList[0].response.data.url;
          that.uploadImgs(fileList);
        }
      } else {
        that.dayImgList = fileList;
        that.uploadImgs(that.dayImgList);
      }
    },

    // 周图表
    weekChart() {
      var that = this;
      var myChart = this.$echarts.init(document.getElementById("week_chart"));
      const y_data = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
      const valueArr = [];
      for (let k in that.weekChartList) {
        valueArr.push(that.weekChartList[k]);
      }
      var option = {
        //提示框，默认显示
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
          // 控制提示格式
          formatter: function(param) {
            return `${param[0].axisValue}: <br/>${param[0].value}人`;
          }
        },
        //控制直角坐标系与容器上下左右的距离
        grid: {
          left: "5%",
          bottom: "0",
          top: "10%",
          containLabel: true //gid区域是否包含坐标轴的刻度标签。
        },
        // x轴（指的是水平的那条线）相关配置
        xAxis: [
          {
            type: "value", //x轴数据类型，value时就是值，category时就是分类，可用于区分y轴与x轴
            name: "分数",
            axisLabel: {
              // 坐标轴标签
              show: true, // 是否显示
              // inside: true, // 标签是否朝内,默认false
              interval: 0, //设置刻度间间隔，0表示全部显示不间隔；auto:表示自动根据刻度个数和宽度自动设置间隔个数
              rotate: 0, // 旋转角度
              margin: 5, // 刻度标签与轴线之间的距离
              color: "#000", // 标签颜色默认取轴线的颜色
              fontSize: 12 //标签字号
            },
            splitLine: {
              // 网格线
              show: false // 是否显示，默认为true
            },
            axisLine: {
              // 坐标轴 轴线
              show: true, // 是否显示,默认false
              lineStyle: {
                // color: '#FFFFFF',//轴线颜色
                width: 1, //轴线宽度
                type: "solid" //轴线类型
              }
            }
          }
        ],
        // y轴（垂直的那条线）设置
        yAxis: [
          {
            type: "category",
            data: y_data, //类目轴数据
            axisLabel: {
              // 坐标轴标签
              show: true, // 是否显示
              inside: false, // 是否朝内
              color: "#000",
              fontSize: 12
            },
            splitLine: {
              // 网格线
              show: false // 是否显示，默认为false
            },
            axisLine: {
              // 坐标轴 轴线
              show: true, // 是否显示
              lineStyle: {
                // color: '#FFFFFF',
                width: 1,
                type: "solid"
              }
            },
            boundaryGap: true, //显示刻度，默认为 true,只是作为分隔线，标签和数据点都会在两个刻度之间的带中间
            axisTick: {
              //坐标轴刻度相关
              alignWithLabel: true //类目轴中在`boundaryGap`为`true`的时候有效，可以保证刻度线和标签对齐
            },
            inverse: true //翻转y轴数据
          }
        ],
        series: [
          {
            type: "bar", //表明柱状体，饼图是pie，折线图是line
            barWidth: 20, //柱子宽度
            data: valueArr, //值数据，与类型数据一一对应
            itemStyle: {
              // emphasis: {
              //     barBorderRadius: 7,
              // },
              normal: {
                //柱子相关设置
                barBorderRadius: [0, 0, 40, 0], //设置柱子圆角;左上-右上-右下-左下
                label: {
                  //柱子标签相关
                  show: true,
                  position: "right", //柱子标签位置
                  textStyle: {
                    //柱子标签文本设置
                    color: "#000",
                    fontSize: 12
                  }
                },
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  1.2,
                  0,
                  [
                    {
                      offset: 0,
                      color: "rgba(21,125,248,0)"
                    },
                    {
                      offset: 1,
                      color: "#157DF8"
                    }
                  ],
                  false
                )
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },

    // 月图表
    monthChart() {
      var that = this;
      var myChart = this.$echarts.init(document.getElementById("month_chart"));
      // x轴数据
      const xAxisData = [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ];
      const seriesData = [];
      for (let k in that.monthChartList) {
        seriesData.push(that.monthChartList[k]);
      }
      var option = {
        color: ["#029AFE"],
        tooltip: {
          trigger: "axis",
          textStyle: { color: "#fff", fontSize: 14 },
          className: "tooltip",
          backgroundColor: "#157DF8" // 设置背景颜色
        },

        grid: {
          left: 12,
          right: 20,
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: "#304265",
              fontSize: 16,
              interval: 0 // 不隔断直接显示
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ccc"
              }
            },
            data: xAxisData
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "分数",
            nameTextStyle: {
              color: "#304265",
              fontSize: 16,
              padding: 10
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: [6, 8],
                color: "#ccc"
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ccc"
              }
            },
            axisLabel: {
              show: true,
              color: "#000",
              fontSize: 16
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            type: "line",
            data: seriesData,

            smooth: true,
            cursor: "default",
            width: 2,

            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(2, 154, 254,.4)"
                    },
                    {
                      offset: 1,
                      color: "rgba(2, 154, 254, 0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(2, 154, 254, .3)",
                shadowBlur: 2
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>
<style scope>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.examine_title_box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: #ffffff;
  padding: 10px;
  border: 1px solid #e4e9f1;
  height: 40px;
}
.examine_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  margin-top: 10px;
  margin-right: 10px;
}
.examine_box {
  margin-top: 10px;
}
.tab_tit {
  font-size: 0;
  width: 450px;
  border-radius: 20px;
  margin: 0 auto;
  background-color: #fff;
}
.tab_tit:hover {
  cursor: pointer;
}
.tab_tit a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  width: 150px;
  text-align: center;
  color: #333;
  text-decoration: none;
}

.tab_tit .cur {
  background: #09f;
  border-radius: 20px;
  color: #fff;
}

/* 我的考核---日 */
.day_list {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 20px 0px;
}
.day_item {
  width: 2%;
  height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* line-height: 40px;
  text-align: center; */
  /* background: #09f;
  color: #fff; */
}
.day_item:hover {
  cursor: pointer;
}
.card_box {
  /* background: seagreen; */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-evenly;
  flex-flow: wrap;
}
.card_item {
  width: 250px;
  height: 157px;
}
.card_title {
  margin-top: 10px;
}
.card_title span {
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #c7ccd5;
}
.title_txt {
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000;
}
.card_data {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.card_data img {
  width: 95px;
  height: 90px;
}
.card_num {
  font-size: 36px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #304265;
}
.upload_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.examine_upload_box {
  padding: 25px;
}
.examine_upload_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #304265;
}
.examine_upload_control {
  /* margin: 10px auto; */
  text-align: center;
  /* margin-top: 25px; */
}
.examine_upload {
  background: #eaf0fa;
  border: 2px dotted #157df8;
  color: #157df8;
  font-size: 23px;
  width: 515px;
  height: 158px;
  line-height: 158px;
}

/* 我的考核---周 */
.week_list {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
}
.week_item {
  width: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* height: 40px;
  line-height: 40px;
  text-align: center; */
}
.week_item:hover {
  cursor: pointer;
}
.week_box {
  padding: 0px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}
.week_chart {
  width: 700px;
  background: #fff;
  padding: 20px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.week_card {
  width: 768px;
  height: 410px;
  display: flex;
  flex-direction: row;
}
.week_card_left {
  width: 480px;
}
.week_card_left_top {
  height: 270px;
  margin-top: 20px;
}
.week_data_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  margin-top: 20px;
}
.week_data_box img {
  width: 100px;
  height: 100px;
  margin-left: 10px;
}
.month_data_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 60px;
  margin-top: 20px;
}
.month_data_box img {
  width: 100px;
  height: 100px;
  margin-left: 10px;
}
.week_card_left_bottom {
  font-size: 13px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.card_line {
  width: 1px;
  height: 370px;
  margin-top: 15px;
  background: #d4d7e0;
}
.week_card_right {
  /* width: 570px; */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: 25px;
}
.week_card_right_item {
  width: 230px;
  height: 95px;
  margin-top: 10px;
}
.week_data_right_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
}
.week_data_right_box img {
  width: 100px;
  height: 100px;
  margin-right: -15px;
}
.checked {
  width: 5px;
  height: 5px;
  background: #157df8;
  border-radius: 15px;
}
.num_box {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.fen {
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  margin-left: 5px;
  margin-bottom: 5px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .card_item {
    width: 345px;
    margin-bottom: 10px;
  }
  .week_box {
    /* display: flex; */
    /* flex-direction: column; */
  }
  .week_card {
    width: 630px;
  }
  .week_chart {
    width: 90%;
    margin-bottom: 10px;
  }
  .week_card_box {
    width: 95%;
  }
  .week_card_left {
    width: 385px;
  }
  .week_card_left_top {
    width: 120px;
  }
  .week_card_right {
    display: flex;
    flex-direction: row;
  }
  .week_data_right_box img {
    margin-right: 15px;
    margin-top: 10px;
  }
  .examine_upload {
    margin-bottom: 20px;
  }
  .week_card_right_item {
    width: 180px;
  }
  .day_item {
    width: 3%;
  }
  .card_num_month {
    margin-left: 75px;
  }
  .month_data_box img {
    margin-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterExamine.vue